// @flow
import { IllegalArgumentException } from "../../exceptions";

import DecimalFormat from "./DecimalFormat";
import { parseNumberToString, parseToNumber } from "./parseNumbers";

/**
 * @private
 */
const updateGroupingSeparator = (input: string, groupingSeparator: string) => {
  if (groupingSeparator == null) {
    return input;
  }

  return input.replace(/,/g, groupingSeparator);
};

/**
 */
const formatValue = (
  value: ?number | ?string,
  format: ?string = "0",
  groupingSeparator: string = ",",
  decimalSeparator: string = ".",
): string => {
  if (value == null) {
    return "";
  }

  const numberValue =
    typeof value === "number"
      ? value
      : parseToNumber(value, groupingSeparator, decimalSeparator);

  if (typeof numberValue !== "number") {
    throw new IllegalArgumentException(
      `Not a valid number: ${value} for formatValue`,
    );
  }

  const stringValue = parseNumberToString(numberValue);

  if (format != null) {
    const formattedValue = new DecimalFormat(format).format(stringValue);

    const [integer, decimal] = formattedValue.split(".");

    const integerPart = updateGroupingSeparator(integer, groupingSeparator);

    if (decimal) {
      return `${integerPart}${decimalSeparator}${decimal}`;
    }

    return integerPart;
  }

  return stringValue;
};

export default formatValue;
